import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import HomeAffiliate from "../views/HomeAffiliate.vue";
import ResellerLists from "../views/ResellerList.vue";
import PinLists from "../views/PinList.vue";
import PinListBatchWises from "../views/PinListBatchWise.vue";
import AddNewResellers from "../views/AddNewReseller.vue";
import EditResellers from "../views/EditReseller.vue";
import loginView from "../views/Login.vue";
import AddSinglePins from "../views/AddSinglePin.vue";
import AddRatePlans from "../views/AddRatePlan.vue";
import BaseRatePlans from "../views/BaseRatePlan.vue";
import RatePlans from "../views/RatePlan.vue";
import EditRatePlans from "../views/EditRatePlan.vue";
import SaleingRatePlans from "../views/SaleingRatePlan.vue";
import EditSaleRates from "../views/EditSaleRate.vue";
import TransferLots from "../views/TransferLot.vue";
import AddPinBatchs from "../views/AddPinBatch.vue";
import EditBatchs from "../views/EditBatch.vue";
import PinBatchLists from "../views/PinBatchList.vue";
import ResellerConnectedUsers from "../views/ResellerConnectedUser.vue";
import AddPanelSettings from "../views/AddPanelSetting.vue";
import PinSubscriptionReportView from "../views/reports/PinSubscriptionReport.vue";
import OnlineTransactionReportView from "../views/reports/OnlineTransactionReport.vue";
import ResellerTransactionReportView from "../views/reports/ResellerTransactionReport.vue";
import PaymentReportView from "../views/reports/PaymentReport.vue";
import IndividualSoldPinReportView from "../views/reports/IndividualSoldPinReport.vue";
import HourlySubscriptionReportView from "../views/reports/HourlySubscriptionReport.vue";
//import CampaignSubscriptionReportView from "../views/reports/CampaignSubscriptionReport.vue";
import CampaignSaleReportView from "../views/reports/CampaignSaleReport.vue";
import CampaignLists from "../views/CampaignList.vue";
import BillingAccountLists from "../views/BillingAccountList.vue";
import AddBillingAccounts from "../views/AddBillingAccount.vue";
import WithdrawLists from "../views/WithdrawList.vue";
import AddNewWithdrawals from "../views/AddNewWithdrawal.vue";
import passwordResetView from "../views/PasswordReset.vue";

import FlexPinLists from "../views/Flex/PinList.vue";
import FlexAddSinglePins from "../views/Flex/AddSinglePin.vue";
import FlexAddPinBatchs from "../views/Flex/AddPinBatch.vue";
import FlexPinBatchLists from "../views/Flex/PinBatchList.vue";
import FlexEditBatchs from "../views/Flex/EditBatch.vue";
import FlexPinListBatchWises from "../views/Flex/PinListBatchWise.vue";
import FlexSinglePinActivations from "../views/Flex/SinglePinActivation.vue";
import FlexPinSubscriptionReportView from "../views/reports/Flex/PinSubscriptionReport.vue";
import FlexPaymentReportView from "../views/reports/Flex/PaymentReport.vue";
import FlexAddNewResellers from "../views/Flex/AddNewReseller.vue";
import FlexEditResellers from "../views/Flex/EditReseller.vue";
import FlexResellerLists from "../views/Flex/ResellerList.vue";
import HomeFlex from "../views/Flex/Home.vue";
import FlexAddPinValidityView from "../views/Flex/AddPinValidity.vue";
import FlexFreePinReportView from "../views/reports/Flex/FreePinReport.vue";
import FlexPromotionMonitoringReportView from "../views/reports/Flex/PromotionMonitoringReport.vue";
import FlexPinBatchSaleReportView from "../views/reports/Flex/PinBatchSaleReport.vue";
import FlexOnlineSubscriptionReport from "../views/reports/Flex/OnlineSubscriptionReport.vue";
import FlexOfflineSubscriptionReport from "../views/reports/Flex/OfflineSubscriptionReport.vue";
import FlexRechargeReport from "../views/reports/Flex/RechargeReport.vue";
import SendPushs from "../views/SendPush.vue";

/*===================Subscription base sales start==================================================*/
//subscription code
import SubscriptionCode from "@/views/SubscriptionBaseSales/subscriptionCode/SubscriptionCodeList.vue";
import SubscribersList from "@/views/SubscriptionBaseSales/subscriptionCode/SubscribersList.vue";
import AddSubscriptionCode from "@/views/SubscriptionBaseSales/subscriptionCode/AddSubscriptionCode.vue";

//subscription batches
import SubscriptionCodeBatch from "@/views/SubscriptionBaseSales/subscriptionBatch/AddSubscriptionCodeBatch.vue";
import SubscriptionCodeBatchList from "@/views/SubscriptionBaseSales/subscriptionBatch/SubscriptionCodeBatchList.vue";
import AllPushRequests from "../views/AllPushRequests.vue";
import AffiliateSalesReport from "../views/AffiliateSalesReport.vue";
import AddDnsBatch from "../views/AddDnsBatch.vue";
import DnsList from "../views/DnsList.vue";
import DnsBatchList from "../views/DnsBatchList.vue";
import EditDnsBatch from "../views/EditDnsBatch.vue";
import DnsListBatchWise from "../views/DnsListBatchWise.vue";
import AddSingleDns from "../views/AddSingleDns.vue";
import BannerList from "../views/BannerList.vue";
import AddBanners from "../views/AddBanner.vue";
import BannerImages from "../views/BannerImage.vue";
import AddBannerImage from "../views/AddBannerImage.vue";
import CampaignCouponDiscountList from "../views/CampaignCouponDiscountList.vue";
import CampaignCouponForm from "../views/CampaignCouponForm.vue";
import CampaignCouponList from "../views/CampaignCouponList.vue";
import CampaignCouponDiscountForm from "../views/CampaignCouponDiscountForm.vue";
import FreeSignupPinsReport from "../views/FreeSignupPinsReport.vue";





/*===================Subscription base sales end==================================================*/

Vue.use(VueRouter);

const routes = [
  {
    path: "/:panel",
    redirect: { name: 'loginView' }
  },
  {
    path: "/:panel/dashboard",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/affiliate-dashboard",
    name: "HomeAffiliate",
    component: HomeAffiliate,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/login",
    name: "loginView",
    component: loginView,
  },
  {
    path: "/:panel/resellerlist",
    name: "ResellerLists",
    component: ResellerLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/campaignlist",
    name: "CampaignLists",
    component: CampaignLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/campaignlist/:id",
    name: "AffiliateSalesReport",
    component: AffiliateSalesReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/resellerlist/:id",
    name: "EditResellers",
    component: EditResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinlist",
    name: "PinLists",
    component: PinLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/dnslists",
    name: "DnsLists",
    component: DnsList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinlist/:id",
    name: "PinListBatchWises",
    component: PinListBatchWises,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/dnslist/:id",
    name: "DnsListBatchWises",
    component: DnsListBatchWise,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addresellers",
    name: "AddNewResellers",
    component: AddNewResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/billingaccountlists",
    name: "BillingAccountLists",
    component: BillingAccountLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addbilllingaccounts",
    name: "AddBillingAccounts",
    component: AddBillingAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/editbilllingaccounts/:id",
    name: "EditBillingAccounts",
    component: AddBillingAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/withdrawlist",
    name: "WithdrawLists",
    component: WithdrawLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addnewwithdrawal",
    name: "AddNewWithdrawals",
    component: AddNewWithdrawals,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/editwithdrawal/:id",
    name: "EditWithdrawals",
    component: AddNewWithdrawals,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addsinglepin",
    name: "AddSinglePins",
    component: AddSinglePins,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addsingledns",
    name: "AddSingleDns",
    component: AddSingleDns,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addrateplans",
    name: "AddRatePlans",
    component: AddRatePlans,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/baserateplans",
    name: "BaseRatePlans",
    component: BaseRatePlans,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/rateplans",
    name: "RatePlans",
    component: RatePlans,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_rateplans/:id",
    name: "EditRatePlans",
    component: EditRatePlans,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/rateplans/:id",
    name: "SaleingRatePlans",
    component: SaleingRatePlans,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/editsalerate/:id",
    name: "EditSaleRates",
    component: EditSaleRates,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addpinbatchs",
    name: "AddPinBatchs",
    component: AddPinBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/adddnsbatchs",
    name: "AddDnsBatchs",
    component: AddDnsBatch,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_batch/:id",
    name: "EditBatchs",
    component: EditBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_dns_batch/:id",
    name: "EditDnsBatchs",
    component: EditDnsBatch,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/transfer_lot/:id",
    name: "TransferLots",
    component: TransferLots,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinbatchlist",
    name: "PinBatchLists",
    component: PinBatchLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/dnsbatchlist",
    name: "DnsBatchLists",
    component: DnsBatchList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/resellerconnectedusers",
    name: "ResellerConnectedUsers",
    component: ResellerConnectedUsers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/panelsettings",
    name: "AddPanelSettings",
    component: AddPanelSettings,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinsubscriptionreport",
    name: "PinSubscriptionReportView",
    component: PinSubscriptionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/onlinetransactionreport",
    name: "OnlineTransactionReportView",
    component: OnlineTransactionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/transactionreport",
    name: "ResellerTransactionReportView",
    component: ResellerTransactionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/paymentreport",
    name: "PaymentReportView",
    component: PaymentReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/individualsoldpinreport",
    name: "IndividualSoldPinReportView",
    component: IndividualSoldPinReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/hourlysubscriptionreport",
    name: "HourlySubscriptionReportView",
    component: HourlySubscriptionReportView,
    meta: { requiresAuth: true }
  },
  // {
  //   path: "/:panel/campaignsubscriptionreport",
  //   name: "CampaignSubscriptionReportView",
  //   component: CampaignSubscriptionReportView,
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/:panel/campaignsalereport",
    name: "CampaignSaleReportView",
    component: CampaignSaleReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/pagenotfound",
    name: "pagenotfound",
    component: () => import("../components/404NotFound.vue")
  },
  {
    path: "/:panel/pagenotfound",
    name: "pagesnotfound",
    component: () => import("../components/404NotFound.vue")
  },
  {
    path: "/:panel/logout",
    redirect: { name: 'loginView' }
  },
  {
    path: "/:panel/passwordReset",
    name: "passwordReset",
    component: passwordResetView,
  },
  {
    path: "/:panel/tvpinlist",
    name: "FlexPinLists",
    component: FlexPinLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addtvsinglepin",
    name: "FlexAddSinglePins",
    component: FlexAddSinglePins,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addtvpinvalidity",
    name: "FlexAddPinValidityView",
    component: FlexAddPinValidityView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvsinglepinactivation",
    name: "FlexSinglePinActivations",
    component: FlexSinglePinActivations,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addtvpinbatchs",
    name: "FlexAddPinBatchs",
    component: FlexAddPinBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpinbatchlist",
    name: "FlexPinBatchLists",
    component: FlexPinBatchLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_tv_batch/:id",
    name: "FlexEditBatchs",
    component: FlexEditBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpinlist/:id",
    name: "FlexPinListBatchWises",
    component: FlexPinListBatchWises,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvresellerlist",
    name: "FlexResellerLists",
    component: FlexResellerLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvaddresellers",
    name: "FlexAddNewResellers",
    component: FlexAddNewResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvresellerlist/:id",
    name: "FlexEditResellers",
    component: FlexEditResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpinsubscriptionreport",
    name: "FlexPinSubscriptionReportView",
    component: FlexPinSubscriptionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvfreesubscriptionreport",
    name: "FlexFreePinReportView",
    component: FlexFreePinReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpromotionmonitoringreport",
    name: "FlexPromotionMonitoringReportView",
    component: FlexPromotionMonitoringReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpinbatchsalereport",
    name: "FlexPinBatchSaleReportView",
    component: FlexPinBatchSaleReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvonlinesubscriptionreport",
    name: "FlexOnlineSubscriptionReport",
    component: FlexOnlineSubscriptionReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvofflinesubscriptionreport",
    name: "FlexOfflineSubscriptionReport",
    component: FlexOfflineSubscriptionReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvrechargereport",
    name: "FlexRechargeReport",
    component: FlexRechargeReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tvpaymentreport",
    name: "FlexPaymentReportView",
    component: FlexPaymentReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/tv-dashboard",
    name: "HomeFlex",
    component: HomeFlex,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/subscribers",
    name: "SubscribersList",
    component: SubscribersList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/subscription-code",
    name: "SubscriptionCode",
    component: SubscriptionCode,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/add-subscription-code",
    name: "AddSubscriptionCode",
    component: AddSubscriptionCode,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/add-subscription-batch",
    name: "AddSubscriptionBatchs",
    component: SubscriptionCodeBatch,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/subscription-batch-list",
    name: "SubscriptionBatchList",
    component: SubscriptionCodeBatchList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/send-push",
    name: "SendPush",
    component: SendPushs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/all-push-requests",
    name: "AllPushRequests",
    component: AllPushRequests,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/banners",
    name: "Banners",
    component: BannerList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/add-banner",
    name: "AddBanner",
    component: AddBanners,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit-banner/:id",
    name: "EditBanner",
    component: AddBanners,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/banner-images/:id",
    name: "BannerImage",
    component: BannerImages,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/banner-image/:banner_id/add",
    name: "AddBannerImage",
    component: AddBannerImage,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/banner-images/:banner_id/edit/:id",
    name: "EditBannerImage",
    component: AddBannerImage,
    meta: { requiresAuth: true }
  },
  // Campaign Coupon Routes
  {
    path: "/:panel/campaign-coupon-list",
    name: "CampaignCouponList",
    component: CampaignCouponList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/add-campaign-coupon",
    name: "AddCampaignCoupon",
    component: CampaignCouponForm,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit-campaign-coupon/:id",
    name: "EditCampaignCoupon",
    component: CampaignCouponForm,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/campaign-coupon-discounts/:id",
    name: "CampaignCouponDiscountList",
    component: CampaignCouponDiscountList,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit-campaign-coupon-discount/:id",
    name: "EditCampaignCouponDiscount",
    component: CampaignCouponDiscountForm,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/free-signup-pins-report",
    name: "FreeSignupPinsReport",
    component: FreeSignupPinsReport,
    meta: { requiresAuth: true }
  }


];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt_token") == null) {
      var panelName = to.params.panel;
      if (panelName) {
        next({
          name: "loginView",
          params: { panel: panelName }
        });
      } else {
        next({
          path: "pagenotfound"
        });
      }

    } else {
      next();
    }
  } else {
    if (to.name == 'loginView') {
      if (localStorage.getItem("jwt_token") == null) {
        next();
      } else {

        /*
          Start:
          When a user is already logged in and new user is trying to login 
          with support login then old session is cleared before route enter
        */
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('credentials')) {
          let credentials = urlParams.get('credentials');
          console.log("Cleared !");
          localStorage.removeItem("jwt_token");
          localStorage.setItem("credentials", credentials);
          next();
        }
        //End:

        var panelName = to.params.panel;
        next({
          name: "Home",
          params: { panel: panelName }
        });
      }
    } else {
      next();
    }
  }
});

export default router;
